import axios from "axios";
import { store } from "../store/store";

const axiosAdmin = axios.create({
  baseURL: `https://training-api.wiessolution.com`,
});

axiosAdmin.interceptors.request.use((config) => {
  const state = store.getState();
  const token = state.auth.auth.idToken;
  config.headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  return config;
});

export default axiosAdmin;
